/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmDenikSslStupenUtajeni extends GContentBase<SeznamAdmDenikSslStupenUtajeniObj> {
        private seznamObj: SeznamAdmDenikSslStupenUtajeniObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmDenikSslStupenUtajeniObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmDenikSslStupenUtajeni",
                contentCaption: "jres:33000629", //RC 33000614 : Spisové uzly navázané na deník
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{sslden} - {st_utaj_id_txt}"
                },
                gridSettings: {
                    columnOrder: "sslden,st_utaj_id_txt,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmDenikSslStupenUtajeniObj extends GAdmSeznamBase {
        sslden: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmDenikSslStupenUtajeni", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmDenikSslStupenUtajeni",
                newRecord: isNew,
                sslden: isNew == true ? ((this.sslden) ? this.sslden : null) : data.sslden,
                st_utaj_id: isNew == true ? null : data.st_utaj_id
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:29808057").addField("gselectbox", Gordic.Prefabs.Select.sslsden(), {
                name: "sslden",
                model: "model.sslden=value.sslden",
                dropdown: true,
                disabled: (this.sslden) ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.sslden) 
                hardFilter["sslden"] = this.sslden
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any, poradi_new?: number) {
            this.cnt.isl.AdmDenikSslStupenUtajeni.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#".format(data.sslden, data.st_utaj_id),
                nazev: "{0} - {1}".format(data["sslden"], data["st_utaj_id_txt"])
            }
        }
    }
}